export const spacing = {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32
};

export const borderRadius = {
    none: 0,
    xs: 2,
    sm: 4,
    md: 6,
    lg: 8,
    xl: 12,
    xxl: 16,
    full: 50 // for circular buttons
};

export const layoutSpacing = {
    labelGap: 6, //gap btw label and input
    iconGap: 10, // gap btw icons
    inputGap: 16, // gap between two inputs
    sectionGap: 18,// gap between two sections or grids
    pagePadding: 8 //padding inside the root container
};
export const fontSizes = {
    xs: 12,
    sm: 13,
    md: 14,
    lg: 15,
    xl: 18,
    xxl: 22
};

export const fontWeights = {
    regular: 400,
    medium: 500,
    semibold: 600
};